/*  STYLES  */
import 'css/src/components/public-pages/Page404';

import React from 'react';

import { Urls } from 'js/src/client';

const PagePrivacy = React.memo(function PagePrivacy() {
    return (
        <section style={{ marginTop: '140px' }}>
            <div className="page-content">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                            <h3>Privacy Policy</h3>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 provides this Privacy Policy to inform you of our policies
                                and procedures regarding the collection, use, protection, and
                                disclosure of Personal Information received from your use of this
                                website, located at&nbsp;
                                <a href="https://lumen5.com">https://lumen5.com</a>
                                &nbsp;(“<strong>Site</strong>”), as well as all related websites
                                including our subdomains, applications, browser extensions, and
                                other services provided by us (collectively, together with the Site,
                                our “Service”), and in connection with our customer, vendor, and
                                partner relationships. This Privacy Policy also tells you about your
                                rights and choices with respect to your Personal Information, and
                                how you can reach us to update your contact information or get
                                answers to questions you may have about our privacy practices.
                            </div>

                            <div className="font-l5 font-l5--regular">
                                Registration with, use of, and access to the Service is subject to
                                this Privacy Policy and our Terms of Use located at&nbsp;
                                <a href={Urls.TERMS}>https://lumen5.com/terms/</a>. All terms not
                                defined in this Privacy Policy will have the meanings set forth in
                                the Lumen5 Terms of Service.
                            </div>

                            <h4 className="mt-l5-48">1. PERSONAL INFORMATION WE MAY COLLECT</h4>

                            <div className="font-l5 font-l5--regular">
                                For the purpose of this Privacy Policy, “Personal Information” means
                                any information relating to an identified or identifiable
                                individual. We obtain Personal Information relating to you from
                                various sources described below.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                Where applicable, we indicate whether and why you must provide us
                                with your Personal Information, as well as the consequences of
                                failing to do so. If you do not provide Personal Information when
                                requested, you may not be able to benefit from our Service if that
                                information is necessary to provide you with the service or if we
                                are legally required to collect it.
                            </div>

                            <h4 className="mt-l5-48">2. PERSONAL INFORMATION PROVIDED BY YOU</h4>

                            <div className="font-l5 font-l5--regular">
                                <strong>Registration</strong>
                                <br />
                                If you desire to have access to certain restricted sections of the
                                Site or request to receive marketing materials, you may be required
                                to become a registered user, and to submit the following types of
                                Personal Information to Lumen5: your name, email address, phone
                                number, full user name, password, city, and time zone.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Customer Support</strong>
                                <br />
                                We may collect information through your communications with our
                                customer support team or other communications that you may send us
                                and their contents.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Making a Purchase</strong>
                                <br />
                                When you make payments through the Service, you will need to provide
                                Personal Information such as your credit card number and billing
                                address.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Social Media</strong>
                                <br />
                                In order to allow you to post to your external platforms, we may ask
                                you to provide your username, account ids, social handle, timezones,
                                and email address.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Other</strong>
                                <br />
                                We may also collect your contact details when you provide them in
                                the context of our customer, vendor, and partner relationships.
                            </div>

                            <h4 className="mt-l5-48">
                                2a. Personal Information Collected from Connected Social Media
                                Accounts
                            </h4>

                            <div className="font-l5 font-l5--regular">
                                If you connect your third party social media account to your Lumen5
                                account, we may collect certain information stored in your social
                                media account such as:
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Facebook</strong>
                                <br />
                                Lumen5 may allow you to connect a Facebook page or profile to your
                                Lumen5 account, in which case we will access certain information
                                from Facebook regarding your account. In particular, we may collect
                                profile image, display name, username / page ID or profile ID,
                                access tokens, and sent posts. This includes the content of your
                                post and engagement data (such as click rates, likes, re-shares,
                                impressions, as well as general engagement counts), to the extent
                                permitted by applicable law. This data will only be used by Lumen5
                                to provide you with the Service you expect and will not be shared
                                with any third parties.
                            </div>

                            <h4 className="mt-l5-48">
                                2b. Personal Information Automatically Obtained from Your
                                Interactions with the Service
                            </h4>

                            <div className="font-l5 font-l5--regular">
                                <strong>Log Data</strong>
                                <br />
                                When you use our Service, our servers automatically record
                                information that your browser sends whenever you visit a website
                                (“Log Data”). This Log Data may include information such as your IP
                                address, browser type or the domain from which you are visiting, the
                                web-pages you visit, the search terms you use, and any
                                advertisements on which you click.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Cookies and Similar Technologies</strong>
                                <br />
                                Like many websites, we use “cookie” technology to collect website
                                usage data and to improve the Site and our Service. A cookie is a
                                small data file that we transfer to your computer’s hard disk. A
                                session cookie enables certain features of the Site and our service
                                and is deleted from your computer when you disconnect from or leave
                                the Site. A persistent cookie remains after you close your browser
                                and may be used by your browser on subsequent visits to the Site.
                                Persistent cookies can be removed by following your web browser help
                                file directions. Most Internet browsers automatically accept
                                cookies. Lumen5 may use both session cookies and persistent cookies
                                to better understand how you interact with the Site and our Service,
                                to monitor aggregate usage by our users and web traffic routing on
                                the Site, and to improve the Site and our Service. We may also
                                automatically record certain information from your device by using
                                various types of technology, including “clear gifs” or “web
                                beacons.” This automatically collected information may include your
                                IP address or other device address or ID, web browser and/or device
                                type, the web pages or sites that you visit just before or just
                                after you use the Service, the pages or other content you view or
                                otherwise interact with on the Service, and the dates and times that
                                you visit, access, or use the Service. We also may use these
                                technologies to collect information regarding your interaction with
                                email messages, such as whether you opened, clicked on, or forwarded
                                a message, to the extent permitted under applicable law. You can
                                control or reset your cookies and similar technologies through your
                                web browser. You can also control which categories of cookies are
                                enabled in your [[Privacy settings]]. Some features of the Service
                                may not function properly if cookies are disabled.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                We may also automatically record certain information from your
                                device by using various types of technology, including “clear gifs”
                                or “web beacons.” This automatically collected information may
                                include your IP address or other device address or ID, web browser
                                and/or device type, the web pages or sites that you visit just
                                before or just after you use the Service, the pages or other content
                                you view or otherwise interact with on the Service, and the dates
                                and times that you visit, access, or use the Service. We also may
                                use these technologies to collect information regarding your
                                interaction with email messages, such as whether you opened, clicked
                                on, or forwarded a message, to the extent permitted under applicable
                                law.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                You can instruct your browser, by editing its options, to stop
                                accepting cookies or to prompt you before accepting a cookie from
                                the websites you visit. Please note that if you delete, or choose
                                not to accept, cookies from the Service, you may not be able to
                                utilize the features of the Service to their fullest potential.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Do Not Track</strong>
                                <br />
                                Lumen5 does not process or respond to web browsers’ “do not track”
                                signals or other similar transmissions that indicate a request to
                                disable online tracking of users who use our Service.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Third Party Web Beacons and Third Party Buttons</strong>
                                <br />
                                We may display third-party content on the Service, including
                                third-party advertising. Third-party content may use cookies, web
                                beacons, or other mechanisms for obtaining data in connection with
                                your viewing of the third party content on the Service.
                                Additionally, we may implement third party buttons, such as Facebook
                                “share” buttons, that may function as web beacons even when you do
                                not interact with the button. Information collected through
                                third-party web beacons and buttons is collected directly by these
                                third parties, not by Lumen5. Please consult such third party’s data
                                collection, use, and disclosure policies for more information.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Links to Other Websites</strong>
                                <br />
                                Our Site contains links to other websites. The fact that we link to
                                a website is not an endorsement, authorization or representation of
                                our affiliation with that third party. We do not exercise control
                                over third party websites. These other websites may place their own
                                cookies or other files on your computer, collect data or solicit
                                Personal Information from you. Other sites follow different rules
                                regarding the use or disclosure of the Personal Information you
                                submit to them. We are not responsible for the content, privacy and
                                security practices, and policies of third-party sites or services to
                                which links or access are provided through the Service. We encourage
                                you to read the privacy policies or statements of the other websites
                                you visit.
                            </div>

                            <h4 className="mt-l5-48">
                                3. HOW WE MAY USE YOUR PERSONAL INFORMATION
                            </h4>

                            <div className="font-l5 font-l5--regular">
                                We may use the Personal Information we obtain about you to:
                                <ul>
                                    <li>
                                        create and manage your account, provide our Service, process
                                        payments, and respond to your inquiries;
                                    </li>
                                    <li>
                                        manage account authentication such as two-factor
                                        authentication;
                                    </li>
                                    <li>
                                        communicate with you to verify your account and for
                                        informational and operational purposes, such as account
                                        management, customer service, or system maintenance,
                                        including by periodically emailing you service-related
                                        announcements;
                                    </li>
                                    <li>
                                        tailor our Service (e.g., we may use cookies and similar
                                        technologies to remember your preferences);
                                    </li>
                                    <li>
                                        publish your content, comments or messages on social media
                                        platforms;
                                    </li>
                                    <li>provide tailored advertising, for Lumen5 services;</li>
                                    <li>
                                        aggregate your Personal Information for analytical purposes;
                                    </li>
                                    <li>provide customer support;</li>
                                    <li>
                                        operate, evaluate and improve our business (including by
                                        developing new products and services; managing our
                                        communications; determining the effectiveness of our
                                        advertising; analyzing how the Service is being accessed and
                                        used; tracking performance of the Service; debugging the
                                        Service; facilitating the use of our Service);
                                    </li>
                                    <li>
                                        send you marketing communications about products, services,
                                        offers, programs and promotions of Lumen5, and affiliated
                                        companies;
                                    </li>
                                    <li>ensure the security of our Service;</li>
                                    <li>
                                        manage our customer, service provider and partner
                                        relationships;
                                    </li>
                                    <li>
                                        enforce our agreements related to our Service and our other
                                        legal rights; and
                                    </li>
                                    <li>
                                        comply with applicable legal requirements, industry
                                        standards and our policies.
                                    </li>
                                </ul>
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                If you are located in the European Economic Area, we may process
                                your Personal Information for the above purposes when:
                                <ul>
                                    <li>
                                        you have consented to the use of your Personal Information,
                                        For example, we may seek to obtain your consent for our uses
                                        of cookies or similar technologies, or to send you marketing
                                        communications.
                                    </li>
                                    <li>
                                        we need your Personal Information to provide you with
                                        services and products requested by you, or to respond to
                                        your inquiries,
                                    </li>
                                    <li>
                                        we have a legal obligation to use your Personal Information,
                                        or
                                    </li>
                                    <li>
                                        we have a legitimate interest in using your Personal
                                        Information. In particular, we have a legitimate interest in
                                        using your Personal Information to ensure and improve the
                                        safety, security, and performance of our Service, to
                                        anonymize Personal Information and carry out data analyses.
                                    </li>
                                </ul>
                            </div>

                            <h4 className="mt-l5-48">4. HOW WE SHARE YOUR PERSONAL INFORMATION</h4>

                            <div className="font-l5 font-l5--regular">
                                We may disclose the Personal Information we collect about you as
                                described below or otherwise disclosed to you at the time the data
                                is collected, including with:
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Social Media Platforms</strong>
                                <br />
                                Our primary purpose for using information collected from connected
                                third party social media platforms is to publish your videos on
                                those platforms and allow you to track metrics for analytical
                                purposes. We may allow you to link your account on Lumen5 with an
                                account on a third party social network platform, such as YouTube or
                                Facebook, and to transfer your information to and from the
                                applicable third party platform. Once you share your content to a
                                social media platform, its use will be governed by that platform’s
                                privacy policy.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Service Providers</strong>
                                <br />
                                We engage certain trusted third parties to perform functions and
                                provide services to us, including hosting and maintenance, error
                                monitoring, debugging, performance monitoring, billing, customer
                                relationship, database storage and management, and direct marketing
                                campaigns. We may share your Personal Information with these third
                                parties, but only to the extent necessary to perform these functions
                                and provide such services. We also require these third parties to
                                maintain the privacy and security of the Personal Information they
                                process on our behalf.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Compliance with Laws and Law Enforcement</strong>
                                <br />
                                Lumen5 cooperates with government and law enforcement officials or
                                private parties to enforce and comply with the law. To the extent
                                permitted under applicable law, we may disclose any information
                                about you to government or law enforcement officials or private
                                parties as we believe is necessary or appropriate to investigate,
                                respond to, and defend against claims, for legal process (including
                                subpoenas), to protect the property and rights of Lumen5 or a third
                                party, to protect Lumen5 against liability, for the safety of the
                                public or any person, to prevent or stop any illegal, unethical,
                                fraudulent, abusive, or legally actionable activity, to protect the
                                security or integrity of the Service and any equipment used to make
                                the Service available, or to comply with the law.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Business Transfers</strong>
                                <br />
                                Lumen5 may sell, transfer or otherwise share some or all of its
                                assets, including Personal Information, in connection with a merger,
                                acquisition, reorganization, sale of assets, or similar transaction,
                                or in the event of insolvency or bankruptcy. You will have the
                                opportunity to opt out of any such transfer if the new entity’s
                                planned processing of your information differs materially from that
                                set forth in this Privacy Policy.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>Other Third Parties</strong>
                                <br />
                                We may share Personal Information with our headquarters and
                                affiliates, and business partners to whom it is reasonably necessary
                                or desirable for us to disclose your data for the purposes described
                                in this Privacy Policy. We may also make certain non-Personal
                                Information available to third parties for various purposes,
                                including for business or marketing purposes or to assist third
                                parties in understanding our users’ interest, habits, and usage
                                patterns for certain programs, content, services, advertisements,
                                promotions, and functionality available through the Service.
                            </div>

                            <h4 className="mt-l5-48">
                                5. HOW WE PROTECT YOUR PERSONAL INFORMATION
                            </h4>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 is very concerned about safeguarding the confidentiality of
                                your Personal Information. We employ administrative and electronic
                                measures designed to appropriately protect your Personal Information
                                against accidental or unlawful destruction, accidental loss,
                                unauthorized alteration, unauthorized disclosure or access, misuse,
                                and any other unlawful form of processing of the Personal
                                Information in our possession. Please be aware that no security
                                measures are perfect or impenetrable. We cannot guarantee that
                                information about you will not be accessed, viewed, disclosed,
                                altered, or destroyed by breach of any of our administrative,
                                physical, and electronic safeguards, subject to requirements under
                                applicable law to ensure or warrant information security.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                We will make any legally-required disclosures of any breach of the
                                security, confidentiality, or integrity of your unencrypted
                                electronically stored Personal Information to you via email or
                                conspicuous posting on our Site in the most expedient time possible
                                and without unreasonable delay, consistent with (i) the legitimate
                                needs of law enforcement or (ii) any measures necessary to determine
                                the scope of the breach and restore the reasonable integrity of the
                                data system , and any other disclosures that may be required under
                                applicable law.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                We also take measures to delete your Personal Information or keep it
                                in a form that does not permit identifying you when this information
                                is no longer necessary for the purposes for which we process it,
                                unless we are required by law to keep this information for a longer
                                period. When determining the retention period, we take into account
                                various criteria, such as the type of products and services
                                requested by or provided to you, the nature and length of our
                                relationship with you, possible re-enrollment with our products or
                                services, the impact on the services we provide to you if we delete
                                some information from or about you, mandatory retention periods
                                provided by law and the statute of limitations.
                            </div>

                            <h4 className="mt-l5-48">6. YOUR RIGHTS AND CHOICES</h4>

                            <div className="font-l5 font-l5--regular">
                                If you decide at any time that you no longer wish to receive such
                                marketing communications from us, please follow the unsubscribe
                                instructions provided in any of the communications. You may also opt
                                out from receiving commercial email from us by sending your request
                                to us by email at&nbsp;
                                <a href="mailto:support@lumen5.com">support@lumen5.com</a>. Please
                                be aware that, even after you opt out from receiving commercial
                                messages from us, you will continue to receive administrative
                                messages from us regarding the Service.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                In certain jurisdictions you have the right to request access and
                                receive information about the Personal Information we maintain about
                                you, to update and correct inaccuracies in your Personal
                                Information, to restrict or object to the processing of your
                                Personal Information, to have the information blocked, anonymized or
                                deleted, as appropriate, or to exercise your right to data
                                portability to transfer your Personal Information to another
                                company. Those rights may be limited in some circumstances by local
                                law requirements. In addition to the above-mentioned rights, you
                                also have the right to lodge a complaint with a competent
                                supervisory authority subject to applicable law.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                Where required by law, we obtain your consent for the processing of
                                certain Personal Information collected by cookies or similar
                                technologies, or used to send you direct marketing communications,
                                or when we carry out other processing activities for which consent
                                may be required. If we rely on consent for the processing of your
                                Personal Information, you have the right to withdraw it at any time
                                and free of charge. When you do so, this will not affect the
                                lawfulness of the processing before your consent withdrawal.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                To update your preferences, ask us to remove your information from
                                our mailing lists, delete your account or submit a request to
                                exercise your rights under applicable law, please contact us as
                                specified in the “How to Contact Us” section below.
                            </div>

                            <h4 className="mt-l5-48">7. DATA TRANSFERS</h4>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 is based in Canada. Personal Information that we collect may
                                be transferred to, and stored at, any of our affiliates, partners or
                                service providers which may be inside or outside the European
                                Economic Area (“EEA”) and Switzerland, including the United States.
                                By submitting your personal data, you agree to such transfers. Your
                                Personal Information may be transferred to countries that do not
                                have the same data protection laws as the country in which you
                                initially provided the information. When we transfer or disclose
                                your Personal Information to other countries, we will protect that
                                information as described in this Privacy Policy.
                            </div>

                            <h4 className="mt-l5-48">8. CHILDREN’S PRIVACY</h4>

                            <div className="font-l5 font-l5--regular">
                                The Site is not directed to persons under 16. If a parent or
                                guardian becomes aware that his or her child has provided us with
                                Personal Information without their consent, he or she should contact
                                us at&nbsp;
                                <a href="mailto:support@lumen5.com">support@lumen5.com</a>. We do
                                not knowingly collect Personal Information from children under 16.
                                If we become aware that a child under 16 has provided us with
                                Personal Information, we will delete such information from our
                                files.
                            </div>

                            <h4 className="mt-l5-48">9. UPDATES TO THIS PRIVACY POLICY</h4>

                            <div className="font-l5 font-l5--regular">
                                This Privacy Policy may be updated from time to time for any reason;
                                each version will apply to information collected while it was in
                                place. We will notify you of any modifications to our Privacy Policy
                                by posting the new Privacy Policy on our Site and indicating the
                                date of the latest revision. You are advised to consult this Privacy
                                Policy regularly for any changes.
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                In the event that the modifications materially alter your rights or
                                obligations hereunder, we will make reasonable efforts to notify you
                                of the change. For example, we may send a message to your email
                                address or generate a pop-up or similar notification when you access
                                the Service for the first time after such material changes are made.
                                Your continued use of the Service after the revised Privacy Policy
                                has become effective indicates that you have read, understood and
                                agreed to the current version of this Privacy Policy.
                            </div>

                            <h4 className="mt-l5-48">10. HOW TO CONTACT US</h4>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 Technologies Ltd is the entity responsible for the processing
                                of your Personal Information. If you have any questions or comments
                                regarding this Privacy Policy, or if you would like to exercise your
                                rights to your Personal Information, you may contact us by emailing
                                us at support@lumen5.com or by writing to us at:
                            </div>

                            <div className="font-l5 font-l5--regular">
                                Lumen5 Technologies Ltd
                                <br />
                                {SERVER?.COMPANY_ADDRESS?.LINE1}
                                <br />
                                {SERVER?.COMPANY_ADDRESS?.LINE2}
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                Pursuant to Article 27 of European Union’s (“EU”) General Data
                                Protection Regulation (“GDPR”), we have appointed a representative
                                in Germany to act as our GDPR representative in the EU, where
                                required (“EU GDPR Representative”). In addition, pursuant to
                                Article 27 of the United Kingdom’s (“U.K.”) General Data Protection
                                Regulation (“U.K. GDPR”), we have appointed a representative in the
                                U.K. to act as our U.K. GDPR representative, where required (“U.K.
                                GDPR Representative”). You can contact our EU GDPR Representative or
                                our U.K. GDPR Representative by sending an email or by writing to
                                the applicable GDPR Representative identified below:
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>EU GDPR Representative:</strong>
                                <br />
                                Rickert Rechtsanwaltsgesellschaft mbH
                                <br />
                                -Lumen5 Technologies Ltd. -
                                <br />
                                Colmantstraße 15
                                <br />
                                53115 Bonn
                                <br />
                                Germany
                                <br />
                                art-27-rep-lumen5@rickert.law
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>UK GDPR Representative: </strong>
                                <br />
                                Rickert Services Ltd UK
                                <br />
                                - Lumen5 Technologies Ltd -
                                <br />
                                PO Box 1487
                                <br />
                                Peterborough
                                <br />
                                PE1 9XX
                                <br />
                                United Kingdom
                                <br />
                                art-27-rep-lumen5@rickert-services.uk
                            </div>

                            <div className="font-l5 font-l5--regular mt-l5-16">
                                <strong>This document was last updated on October 1, 2024.</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});

export default PagePrivacy;
